<template>
  <div class="container">
    <Header :present-page="presentPage" />
    <a-row class="top">
      <a-col class="ipt">
        <span>数据来源</span>
        <a-select
          class="a-select"
          ref="select"
          v-model:value="siteId"
          placeholder="请选择"
          @change="handleDataFrom"
        >
          <a-select-option
            v-for="item in dataFrom"
            :key='item'
            :value="item.value"
          >
            {{item.siteId}}
          </a-select-option>
        </a-select>
        <a-divider type="vertical" />
      </a-col>
      <a-col class="ipt">
        <span>设备名称</span>
        <a-input
          v-model:value="searchData.deviceName"
          placeholder="请输入"
        />
        <a-divider type="vertical" />
      </a-col>
      <a-col class="ipt">
        <span>设备ID</span>
        <a-input
          v-if="siteId == 0"
          v-model:value="searchData.deviceUuid"
          placeholder="请输入"
        />
        <a-input
          v-else
          v-model:value="searchData.deviceId"
          placeholder="请输入"
        />
        <a-divider type="vertical" />
      </a-col>
      <a-col class="ipt">
        <span>上云时间</span>
        <a-range-picker
          v-model:value="time"
          @change="rangePicker"
          showTime
        />
        <a-divider type="vertical" />
      </a-col>
      <!-- <a-col class="ipt">
        <span>创建时间</span>
        <a-range-picker
          v-model:value="time2"
          @change="rangePicker2"
          showTime
        />
        <a-divider type="vertical" />
      </a-col> -->
      <a-col class="operate">
        <a-button
          type="primary"
          @click="search"
        >查询</a-button>
        <a-button
          type="default"
          @click="reset"
        >重置</a-button>
        <a-button
          type="primary"
          @click="download"
        >下载</a-button>
      </a-col>
    </a-row>
    <a-table
      v-if="siteId == 0"
      rowKey="id"
      :pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      :scroll="{ x: 4500 }"
      @change="change"
    >
    </a-table>
    <a-table
      v-else
      rowKey="id"
      :pagination="pagination2"
      :columns="columns2"
      :data-source="dataSource2"
      :scroll="{ x: 2500 }"
      @change="change"
    >
    </a-table>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import { dataHistory, dataHistoryOut, dataHistory2, dataHistoryOut2 } from "@/api/warning/warning.js";
import { deviceList, getDevice, getDeviceOutside } from "@/api/project/project.js";
// yarn global remove js-file-download
export default {
  name: "history",
  components: {
    Header,
  },
  data() {
    return {
      presentPage: '',
      siteId: 0,
      deviceList: [],
      deviceList2: [],
      dataFrom: [
        {
          value: 0,
          siteId: '站内'
        }, {
          value: 1,
          siteId: '站外'
        }
      ],
      searchData: {
        deviceName: '',
        deviceId: '',
        deviceUuid: '',
        cloudStartTime: '',
        cloudEndTime: '',
        createStartTime: '',
        createEndTime: '',
        export: false
      },
      time: [],
      time2: [],
      query: {
        pageNum: 1,
        pageSize: 10
      },
      pagination: {
        size: 'small',
        showSizeChanger: true,
        showQuickJumper: true,
        pageSize: 10,
        showTotal: total => `共 ${total} 条`,
        total: 0
      },
      pagination2: {
        size: 'small',
        showSizeChanger: true,
        showQuickJumper: true,
        pageSize: 10,
        showTotal: total => `共 ${total} 条`,
        total: 0
      },
      columns: [ // 站内
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          width: 250
        },
        {
          title: '设备id',
          dataIndex: 'deviceUuid',
          width: 150
        },
        {
          title: '设备状态',
          dataIndex: 'devStu',
        },
        {
          title: '电池电压(V)',
          dataIndex: 'devBat',
        },
        {
          title: '信号质量(dBm)',
          dataIndex: 'nbCsq',
        },
        {
          title: '坐标',
          dataIndex: 'location',
        },
        {
          title: '在线',
          dataIndex: 'online',
        },
        {
          title: '载荷1(kN)',
          dataIndex: 'press1',
        },
        {
          title: '载荷2(kN)',
          dataIndex: 'press2',
        },
        {
          title: '载荷3(kN)',
          dataIndex: 'press3',
        },
        {
          title: '载荷4(kN)',
          dataIndex: 'press4',
        },
        {
          title: '载荷5(kN)',
          dataIndex: 'press5',
        },
        {
          title: '载荷1温漂b1(mv)',
          dataIndex: 'tempb1',
        },
        {
          title: '载荷2温漂b2(mv)',
          dataIndex: 'tempb2',
        },
        {
          title: '载荷3温漂b3(mv)',
          dataIndex: 'tempb3',
        },
        {
          title: '载荷4温漂b4(mv)',
          dataIndex: 'tempb4',
        },
        {
          title: '载荷1温漂k1(mv)',
          dataIndex: 'tempk1',
        },
        {
          title: '载荷2温漂k2(mv)',
          dataIndex: 'tempk2',
        },
        {
          title: '载荷3温漂k3(mv)',
          dataIndex: 'tempk3',
        },
        {
          title: '载荷4温漂k4(mv)',
          dataIndex: 'tempk4',
        },
        {
          title: '载荷1电压(mv)',
          dataIndex: 'volt1',
        },
        {
          title: '载荷2电压(mv)',
          dataIndex: 'volt2',
        },
        {
          title: '载荷3电压(mv)',
          dataIndex: 'volt3',
        },
        {
          title: '载荷4电压(mv)',
          dataIndex: 'volt4',
        },
        {
          title: '参考电压(mv)',
          dataIndex: 'volt5',
        },
        {
          title: '载荷1零漂c1(mv)',
          dataIndex: 'zeroc1',
        },
        {
          title: '载荷2零漂c2(mv)',
          dataIndex: 'zeroc2',
        },
        {
          title: '载荷3零漂c3(mv)',
          dataIndex: 'zeroc3',
        },
        {
          title: '载荷4零漂c4(mv)',
          dataIndex: 'zeroc4',
        },
        {
          title: '硬件版本',
          dataIndex: 'hwVsn',
        },
        {
          title: '固件版本',
          dataIndex: 'fwVsn',
        },
        {
          title: '上云时间',
          dataIndex: 'timeCloud',
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        // },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   slots: {
        //     customRender: 'action',
        //   },
        // }
      ],
      columns2: [ // 站外
        {
          title: '设备名称',
          dataIndex: 'deviceName',
        },
        {
          title: '设备类型',
          dataIndex: 'devType',
        },
        {
          title: '设备id',
          dataIndex: 'devId',
        },
        {
          title: '参数1',
          dataIndex: 'val1',
        },
        {
          title: '参数2',
          dataIndex: 'val2',
        },
        {
          title: '参数3',
          dataIndex: 'val3',
        },
        {
          title: '参数4',
          dataIndex: 'val4',
        },
        {
          title: '参数5',
          dataIndex: 'val5',
        },
        {
          title: '参数6',
          dataIndex: 'val6',
        },
        {
          title: '参数7',
          dataIndex: 'val7',
        },
        {
          title: '参数8',
          dataIndex: 'val8',
        },
        {
          title: '参数9',
          dataIndex: 'val9',
        },
        {
          title: '参数10',
          dataIndex: 'val10',
        },
        {
          title: '参数11',
          dataIndex: 'val11',
        },
        {
          title: '参数12',
          dataIndex: 'val12',
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        // },
      ],
      dataSource: [],
      dataSource2: [],
      deviceLists: []
    }
  },
  mounted() {
    this.presentPage = this.$route.query.name
    this.init()
    deviceList(this.query).then(res => { //设备列表
      if (res.code == 200) {
        this.deviceLists = res.data.list
      }
    }).catch(res => {
      console.log(res)
    });
    getDevice().then(res => { //站内
      if (res.code === 200) {
        this.deviceList = res.data
      }
    })
    getDeviceOutside(this.pagination).then(res => { // 站外
      if (res.code === 200) {
        for (let i = 0; i < res.data.list.length; i++) {
          const element = res.data.list[i];
          this.deviceList2[i] = { id: '' }
          this.deviceList2[i].id = element
        }
      }
    })
    dataHistoryOut(this.query).then(res => { //预警信息列表
      if (res.code == 200) {
        if (res.data.total == 0) {
          this.$message.error('暂无数据');
        }
        this.dataSource2 = res.data.list
        this.pagination2.total = res.data.total
      }
    }).catch(res => {
      console.log(res)
    });
  },
  methods: {
    handleDataFrom(value) {
      console.log(value)
      this.siteId = value
    },
    rangePicker(value, dateString) {
      // console.log(value, dateString)
      this.searchData.cloudStartTime = dateString[0]
      this.searchData.cloudEndTime = dateString[1]
    },
    rangePicker2(value, dateString) {
      // console.log(value, dateString)
      this.searchData.createStartTime = dateString[0]
      this.searchData.createEndTime = dateString[1]
    },
    search() {
      this.query.filterDate = this.searchData
      this.init()
    },
    reset() {
      this.searchData.deviceName = ''
      this.searchData.deviceUuid = ''
      this.searchData.cloudStartTime = ''
      this.searchData.cloudEndTime = ''
      this.searchData.createStartTime = ''
      this.searchData.createEndTime = ''
      this.time = []
      this.time2 = []
      this.search()
    },
    download() {
      this.searchData.export = true
      this.query.filterDate = this.searchData
      if (this.siteId == 0) { //站内历史数据
        dataHistory2(this.query).then(res => {
          if (this.searchData.export) {
            let blob = new Blob([res], { type: res.type });
            let downloadFilename = '历史数据' + new Date();//设置导出的文件名 
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              //兼容ie浏览器
              window.navigator.msSaveOrOpenBlob(blob, downloadFilename)
            } else {
              //谷歌,火狐等浏览器
              let url = window.URL.createObjectURL(blob);
              let downloadElement = document.createElement("a");
              downloadElement.style.display = "none";
              downloadElement.href = url;
              downloadElement.download = downloadFilename;
              document.body.appendChild(downloadElement);
              downloadElement.click();
              document.body.removeChild(downloadElement);
              window.URL.revokeObjectURL(url);
            }
            this.$message.success('下载成功');
          }
        }).catch(res => {
          console.log(res)
        });
      } else { // 站外历史数据
        dataHistoryOut2(this.query).then(res => {
          if (this.searchData.export) {
            let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
            let downloadFilename = '历史数据' + new Date()//设置导出的文件名 
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              //兼容ie浏览器
              window.navigator.msSaveOrOpenBlob(blob, downloadFilename)
            } else {
              //谷歌,火狐等浏览器
              let url = window.URL.createObjectURL(blob);
              let downloadElement = document.createElement("a");
              downloadElement.style.display = "none";
              downloadElement.href = url;
              downloadElement.download = downloadFilename;
              document.body.appendChild(downloadElement);
              downloadElement.click();
              document.body.removeChild(downloadElement);
              window.URL.revokeObjectURL(url);
            }
            this.$message.success('下载成功');
          }
        }).catch(res => {
          console.log(res)
        });
      }
    },
    init() {
      if (this.siteId == 0) { //站内历史数据
        dataHistory(this.query).then(res => {
          if (res.code == 200) {
            if (res.data.total == 0) {
              this.$message.error('暂无数据');
            }
            this.dataSource = res.data.list
            this.pagination.total = res.data.total
          }
        }).catch(res => {
          console.log(res)
        });
      } else { // 站外历史数据
        dataHistoryOut(this.query).then(res => {
          if (res.code == 200) {
            if (res.data.total == 0) {
              this.$message.error('暂无数据');
            }
            this.dataSource2 = res.data.list
            this.pagination2.total = res.data.total
          }
        }).catch(res => {
          console.log(res)
        });
      }
    },
    change(pagination) {
      console.log(pagination)
      this.query = {
        pageNum: pagination.current,
        pageSize: pagination.pageSize
      }
      this.init()
    },
    goto(path) {
      console.log(path)
      this.$router.push({ path: path }, () => { }).catch(res => {
        console.log(res)
      });
    },
  }
};
</script>
<style scoped>
.top {
  height: 76px;
  padding: 20px 30px;
  line-height: 36px;
  background: #fff;
}

.ipt {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: left;
}
.ipt span {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.ipt input {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-divider-vertical {
  height: 22px;
  margin: 0 15px;
  background: #dddddd;
}
.ant-select :deep() .ant-select-selector {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item {
  height: 34px;
  line-height: 34px;
}
.ipt :deep() .ant-calendar-picker {
  width: 236px;
}
.ipt :deep() .ant-calendar-picker-input {
  width: 100%;
  height: 36px;
  border-radius: 6px;
}
.operate {
  text-align: left;
}
.operate button:nth-child(1),
.operate button:nth-child(3) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.operate button:nth-child(2) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}
.add button {
  width: 80px;
  height: 36px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.ant-table-wrapper {
  margin: 0 30px;
}
.ant-table-wrapper :deep() .ant-table-thead > tr > th,
.ant-table-wrapper :deep() .ant-table table {
  text-align: center;
}
.ant-table-wrapper .ant-btn {
  width: 66px;
  height: 24px;
  padding: 0;
  margin: 0 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  border-radius: 4px;
}
.alter {
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
}
.del {
  color: #ff4444;
  background: #fff;
  border: 1px solid #ff4444;
}
.container :deep() .ant-tabs-bar {
  margin: 0 30px;
  text-align: left;
  background: #fff;
}
</style>
